import VClamp from 'vue3-text-clamp'

// https://github.com/sherwinshen/vue3-text-clamp/issues/9#issuecomment-2254682024
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VClamp)
})
